<template>
	<div class="product-list">
		<div class="bg">
			<img :src="imgUrl" alt="">
		</div>
		<div class="list-width">
			<div class="search-bar">
				<Row :gutter="0" justify="center">
					<Col span="13" class="hot">
						<strong>热门搜索：</strong>
						<a v-for="item in words" @click="searchHot(item.word)">
							{{item.word}}&nbsp;&nbsp;
						</a>
					</Col>
					<Col span="9" style="padding-right: 5px">
						<Input v-model="searchValue">
							<Icon type="ios-search" slot="prefix" />
						</Input>
					</Col>
					<Col span="2">
						<button class="search-button" @click="search()">搜索</button>
					</Col>
				</Row>
			</div>
			<div class="classify">
				<Row :gutter="0" justify="center">
					<Col span="24" class="hot">
						<strong>按标签分类：</strong>
						<a v-for="(item,index) in details.lables" @click="searchHot(item.name)">{{item.name}}&nbsp;&nbsp;</a>
					</Col>
				</Row>
			</div>
			<div class="product-details">
				<h3>{{details.name}}</h3>
				<h2>车型参数</h2>
				<div class="content" v-html="details.description"></div>
				<div class="img-content" v-for="(item,index) in imageType">
					<h2>{{item.name}}
						<router-link tag="a" :to="{ name:'more', params: { images: item.imgs }}">更多</router-link>
					</h2>
					<span v-for="(i,n) in item.imgs">
						<img :src="i.url"/>
					</span>
				</div>
				<div style="text-align: right; position: relative; top: 20px" class="social-share"></div>
			</div>

		</div>
	</div>
</template>

<script>
	import * as product from '@/controller/product'

	export default {
		name: "list-details",
		data() {
			return {
				searchValue: '',
				classify: '',
				details: '',
				imageType: [],
				images:[],
				words: '',
				imgUrl: ''
			}
		},
		mounted() {
			if(this.$route.query.product_id) {
				this.showDetails()
			}else {
				this.$router.push({ name: 'product-list'})
			}
			this.hotWords()
			this.showBanner()
			this.add()
			// console.log('navigator.geolocation->',navigator.geolocation)
		},
		methods: {
			// 初始化地图
            initMap() {

                this.mapObj = new AMap.Map('container', {
                    resizeEnable: true, //自适应大小
                    // center: [this.location.longitude, this.location.latitude],
                    zoom: 10//初始视窗
                })
            },
			//显示banner图
			showBanner() {
				product.fetchBanner()
					.then(result => {
						this.imgUrl = result.imgUrl.product
					})
			},
			//搜索
			search() {
				this.$router.push({ name: 'product-list', query: { words: this.searchValue }})
			},
            searchHot(hotword) {
                this.$router.push({ name: 'product-list', query: { words: hotword }})
            },
			showDetails() {
				product.fetchProductDetails(this.$route.query.product_id)
					.then(result => {
						this.details = result.list

                        socialShare('.social-share', {
                            url: window.location.href + '/news-details?news_id=' + result.list.id +'',
                            title: result.list.name,
                            disabled: ['google', 'facebook', 'twitter'],
                            wechatQrcodeTitle: "微信扫一扫：分享",
                            wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>',
                        })
					})
				product.fetchProductImg(this.$route.query.product_id)
					.then(result => {
						this.imageType = JSON.parse(result.img.image_types)
					})
			},
			//添加访问记录
			add() {
                product.add(this.$route.query.product_id)
			},
			//热词
			hotWords() {
				product.fetchHotWords()
					.then(result => {
						this.words = result.list
					})
			}
		}
	}
</script>

<style scoped lang="stylus">
	.product-list
		background-color #F5F5F5
		.bg
			background-color #EAEAEA
			height 100px
			overflow hidden
			z-index 1
		.list-width
			width 1000px
			margin 0 auto
			position relative
			top -60px
			z-index 9
			.search-bar
				background-color #B5B5B5
				padding 3px
				.search-button
					float right
					width 64px
					height 32px
					background-color #E5001F
					border none
					border-radius 4px
					color white
					outline none
					cursor pointer
				i
					color #DB1232
					font-size 18px
				input
					width 100%
					height 32px
					outline none
					border none
				.hot
					text-align left
					padding-top 7px
					padding-left 15px
					a
						color white
			.classify
				background-color white
				height 40px
				.hot
					text-align left
					padding-top 10px
					padding-left 15px
					a
						font-size 14px
			.product-details
				text-align left
				h3
					color #DB1232
					padding  15px
				h2
					font-weight normal
					padding  10px 15px
					border-bottom 1px solid #E1E1E1
					border-top 1px solid #606266
					a
						float right
						font-size 13px
						margin-top 5px
						color #606266
				.content
					padding 10px
					width 1000px
					min-height 300px
				.content >>> img
					max-width 100%
				.img-content
					img
						width 323px
						margin 5px
</style>
